import { useEffect, useState } from "react";
import type { AnimationEvent, CSSProperties } from "react";
import NaviBaseN from "../Navii_N.png";
import NaviStar from "../Navii_star.png";
import "./NaviiIcon.css";

export type NaviiLogoProps = {
  isSearching?: boolean;
  size?: number;
  className?: string;
};

/**
 * The star uses a tightly cropped asset and its own positioned wrapper. This
 * keeps the visible star centered during rotation without moving the N.
 */
export function NaviiLogo({ isSearching = false, size = 48, className = "" }: NaviiLogoProps) {
  const [isRotating, setIsRotating] = useState(isSearching);
  const logoStyle = { "--navi-logo-size": `${size}px` } as CSSProperties;

  useEffect(() => {
    if (isSearching) {
      setIsRotating(true);
    }
  }, [isSearching]);

  const finishCurrentRotation = (event: AnimationEvent<HTMLSpanElement>) => {
    if (event.animationName === "navi-star-searching" && !isSearching) {
      setIsRotating(false);
    }
  };

  return (
    <span
      className={`navi-logo${className ? ` ${className}` : ""}`}
      style={logoStyle}
      role="img"
      aria-label="Navii"
    >
      <img className="navi-logo__base" src={NaviBaseN} alt="" draggable={false} />
      <span
        className={`navi-logo__star-wrapper${
          isRotating ? " navi-logo__star-wrapper--searching" : ""
        }`}
        onAnimationIteration={finishCurrentRotation}
        aria-hidden="true"
      >
        <img className="navi-logo__star" src={NaviStar} alt="" draggable={false} />
      </span>
    </span>
  );
}
